
import "./solutions.scss";

const Solutions : React.FC =()=>{
    return (
        <div className="solution-wrapper">
            <h1>Solutions</h1>
        </div>
    )
};

export default Solutions;